// NPM
import React, { Component } from 'react';
import { isEmpty } from 'lodash';
import BlockNavigationButton from './BlockNavigationButton';

class CommitBlockButton extends Component {
  commitBlock = () => {
    const { commitQuestionBlock, currentQuestionBlockId } = this.props;
    commitQuestionBlock(currentQuestionBlockId);
  };

  disableBlockCommit = () => {
    const { questions, isLoading } = this.props;
    return (
      isLoading ||
      !questions
        .filter(question => !question.skippable)
        .every(this.hasValidAnswer)
    );
  };

  hasValidAnswer = question => {
    const { answers } = this.props;
    const answer = answers[question.id];
    if (typeof answer === 'object') {
      return !isEmpty(answer);
    } else {
      return answer === 0 || !!answer;
    }
  };

  render() {
    const { isLoading } = this.props;
    return (
      <BlockNavigationButton
        className={`CommitBlockButton ${isLoading ? 'loading' : ''}`}
        onClick={this.commitBlock}
        disabled={this.disableBlockCommit()}
      >
        Next
      </BlockNavigationButton>
    );
  }
}

export default CommitBlockButton;



// WEBPACK FOOTER //
// ./src/Components/Pages/Survey/CommitBlockButton.js